import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do dental practices get more new patients?",
    "a": "Service-specific pages plus a tuned GBP plus review velocity. Patients search by service ('Invisalign', 'dental implants', 'veneers'). Pages that rank for each service capture every intent."
  },
  {
    "q": "Is Google Ads profitable for dental?",
    "a": "Yes for implants, Invisalign, and cosmetic — case values justify high CPCs. For general checkups, GBP and SEO carry more value per dollar."
  },
  {
    "q": "How important are reviews?",
    "a": "Decisive — review count and velocity drive Map Pack rank and new-patient calls. We build review workflows into your front-desk process."
  },
  {
    "q": "Do you market specialty dental (oral surgery, perio, endo)?",
    "a": "Yes — each specialty is a separate marketing ecosystem with its own search intent and case value. Specialty pages convert at premium fees."
  },
  {
    "q": "Are HIPAA considerations handled?",
    "a": "Yes — forms, analytics, and ad tracking are configured to respect PHI from day one."
  }
];

export const Route = createFileRoute("/dentist-marketing-colorado")({
  head: () =>
    industryMarketingHead("Dental Practice", "dental practice", "dentist-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Dental Practice"}
      industryLower={"dental practice"}
      slug={"dentist-marketing-colorado"}
      subheadline={"We help Colorado dental practices — general, family, cosmetic — fill the schedule with high-value new patients across every service."}
      painPoints={["Insurance directory leads are price-shoppers, not patients","Implants and cosmetic case volume is below capacity","Your site doesn't reflect the quality your team delivers"]}
      serviceDescriptions={{
        seo: "Rank for dentist, implants, Invisalign, veneers, cosmetic, and every service across every Colorado market.",
        googleMaps: "Own 'dentist near me' in the Map Pack with review velocity that drives new-patient calls.",
        webDesign: "Service-specific pages — implants, ortho, cosmetic — with case galleries and online booking.",
        ppc: "High-margin Google Ads for implants, Invisalign, and cosmetic cases with strong ROAS.",
        geoAi: "Get cited when patients ask ChatGPT 'best dentist in Denver' or 'dental implants near me'.",
        socialMedia: "Team-led content that builds trust and converts shoppers into booked new-patient exams.",
      }}
      testimonial={{"quote":"Implant case volume tripled in four months. The implant page and ads pay for themselves every week.","role":"Practice Owner, General & Cosmetic Dentistry","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Dental marketing in Colorado Springs","description":"New-patient marketing for dental practices across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Dental marketing in Denver","description":"Compete for new patients in Denver's saturated dental market."},{"to":"/boulder-digital-marketing","label":"Dental marketing in Boulder","description":"Reach Boulder's health-conscious patient base."}]}
    />
  ),
});
